"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useIsAboveBreakpoint;

var _useMediaQuery = _interopRequireDefault(require("../../useMediaQuery"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useIsAboveBreakpoint(breakpoint) {
  const matchesQuery = (0, _useMediaQuery.default)(`(min-width:${breakpoint}px)`);
  if (!breakpoint) return undefined;
  return matchesQuery;
}